<script setup lang="ts">
import { useRouteId } from '@/composables/useRouteId'
import { onMounted, ref, computed, watch } from 'vue';
import { getBatchList, getBatchById } from '@/api/batches'

const props = defineProps({
  batchId: {
    type: String,
    default: null
  },
  isReturnedBatch: {
    type: Boolean,
    default: false
  },
  returnedBatchData: {
    type: Object,
    default: null
  }
})

const routeId = useRouteId();
const currentBatchId = computed(() => props.batchId || routeId);

const batchList = ref<any>([])
const singleBatch = ref<any>(null)
const loading = ref(false)

const fetchSingleBatch = async (id: string) => {
  if (!id) return;

  loading.value = true;
  try {
    singleBatch.value = await getBatchById(id);
  } catch (error) {
    console.error("Error fetching batch by ID:", error);
  } finally {
    loading.value = false;
  }
};

const batchNo = computed(() => {
  if (props.isReturnedBatch && props.returnedBatchData) {
    return props.returnedBatchData.batchNumber || 'Batch not found';
  }

  if (singleBatch.value) {
    return singleBatch.value.batchNumber;
  }

  const batch = batchList.value.find((batch: { id: string }) => {
    return batch.id === currentBatchId.value;
  });

  return batch ? batch.batchNumber : 'Batch not found';
});

watch(currentBatchId, (newId) => {
  if (newId && !props.isReturnedBatch) {
    fetchSingleBatch(newId);
  }
}, { immediate: true });

onMounted(async () => {
  if (!props.isReturnedBatch) {
    batchList.value = await getBatchList();

    if (currentBatchId.value) {
      await fetchSingleBatch(currentBatchId.value);
    }
  }
})
</script>

<template>
  <div class="bg-primary-300 bg-opacity-25 border border-primary-500 text-primary-500 py-3 px-5 pe-20 rounded-lg">
    <span v-if="loading && !isReturnedBatch">Loading batch number...</span>
    <span v-else>Batch Number: {{ batchNo }}</span>
  </div>
</template>

<style scoped>

</style>